import type { FieldPolicy } from "@apollo/client"

export const getLandregister: FieldPolicy = {
  keyArgs(args) {
    const { cadastreNumber, type, pdf } = args.input
    return JSON.stringify({ cadastreNumber, type, pdf })
  }
}
